<div class="site-root">
  <router-outlet name="header"></router-outlet>

  <!--  We could opt to set the margin top rather than creating a page header block for each page.-->
  <main class="site-content" [@routerAnimations]="o.isActivated ? o.activatedRoute : ''">
    <router-outlet #o="outlet"></router-outlet>
  </main>
  <!--  For the time being, this prevents bottom of page from being hidden behind the footer.-->

  <router-outlet name="footer"></router-outlet>
  <link appMoveToHead href="/dynamic/css/unbranded.css" rel="stylesheet" />
</div>
